import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

import AlertPageLayout from 'src/components/AlertPageLayout';
import Auth from 'src/api/auth';

type LocationState = {
  message?: string;
  subMessage?: string;
};

const Error = () => {
  const location = useLocation<LocationState>();

  useEffect(() => {
    Auth.logout();
  }, []);

  const pageTitle =
    location.state && location.state.message
      ? location.state.message
      : 'We are unable to process your request due to an internal system error. Please try again later.';

  return <AlertPageLayout pageTitle={pageTitle} variant='info' />;
};

export default Error;
